function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import './ImmersiveSubheader.module.scss';
import whitelistProps from '../../../utils/whitelistProps';
import styles from './ImmersiveSubheader.module.scss';
import cs from 'classnames';
var whitelist = whitelistProps();
export default function ImmersiveSubheader(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$indent = _ref.indent,
    indent = _ref$indent === void 0 ? '100px' : _ref$indent,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    attrs = _objectWithoutProperties(_ref, ["children", "className", "indent", "style"]);
  var additionalAttrs = whitelist(attrs);
  var styl = useMemo(function () {
    return Object.assign({}, {
      paddingLeft: indent
    }, style);
  }, [style, indent]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: cs(styles.immersiveSubheader, _defineProperty({}, className, className))
  }, additionalAttrs, {
    style: styl
  }), children);
}